// extracted by mini-css-extract-plugin
export default {"steps":"BookingSteps_steps__9+5oC","step":"BookingSteps_step__HqcOy","num":"BookingSteps_num__Umztp","done":"BookingSteps_done__zs3kF","now":"BookingSteps_now__-cIKB"};